import { useDispatch } from 'react-redux';
import claroLogoFooter from '../assets/images/claro_logo_footer.svg';
import { getSession } from '../redux/Slice/sessionSlice';

const ErrorFooter = () => {
    const year = new Date().getFullYear();
    const dispatch = useDispatch();

    const handleClick = () => {
        dispatch(getSession());
    };

    return (
        <footer className='footer error-footer' onClick={handleClick}>
            <div>
                <img src={claroLogoFooter} alt='Claro Logo' />
            </div>
            <p>Todos los derechos reservados, Claro {year}</p>
        </footer>
    );
};

export default ErrorFooter;